import { useLocation } from "react-router-dom";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/ThemeToggle";
import { NAV_ICON_BTN } from "./navStyles";

// Maps a route to its page title. Ordered longest-first so detail routes
// (e.g. /feedback/:id) resolve to their base label.
const PAGE_TITLES: { prefix: string; title: string }[] = [
  { prefix: "/organizations", title: "Organizations" },
  { prefix: "/pricing", title: "Pricing" },
  { prefix: "/feedback", title: "Feedback" },
  { prefix: "/logs", title: "Logs" },
  { prefix: "/system-messages", title: "System Messages" }
];

const getPageTitle = (pathname: string): string => {
  const match = PAGE_TITLES.filter(
    ({ prefix }) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  ).sort((a, b) => b.prefix.length - a.prefix.length)[0];
  return match?.title ?? "Admin";
};

export const Navbar = () => {
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-20 h-[60px] flex items-center gap-4 px-6 border-b bg-background/85 backdrop-blur-md">
      <SidebarTrigger className={`${NAV_ICON_BTN} [&_svg]:size-4`} />
      <h1 className="text-base font-semibold tracking-[-0.01em] text-foreground">
        {getPageTitle(pathname)}
      </h1>

      <div className="flex-1" />

      <ThemeToggle />
    </header>
  );
};
